import { useTranslation } from 'react-i18next';
import { OverviewKpiWidget } from './widgets/OverviewKpiWidget';
import { DocOpenPscLnpWidget } from './widgets/DocOpenPscLnpWidget';
import { DocOpenOtherWidget } from './widgets/DocOpenOtherWidget';
import { LotResiduoWidget } from './widgets/LotResiduoWidget';
import { PackagingStockWidget } from './widgets/PackagingStockWidget';
import { CategoryAggregateWidget } from './widgets/CategoryAggregateWidget';
import { MovementsInMonthWidget } from './widgets/MovementsInMonthWidget';
import { MovementsOutMonthWidget } from './widgets/MovementsOutMonthWidget';

export function DashboardPage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold text-slate-900">{t('dashboard.title')}</h2>

      <OverviewKpiWidget />

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <DocOpenPscLnpWidget />
        <DocOpenOtherWidget />
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
        <LotResiduoWidget />
        <PackagingStockWidget />
        <CategoryAggregateWidget />
      </div>

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <MovementsInMonthWidget />
        <MovementsOutMonthWidget />
      </div>
    </div>
  );
}
